module.exports = __webpack_public_path__ + "img/Moonpull-Share-onblack.b010e8c8.png";